import { useEffect, useState } from 'react';
import { apiEndpoint } from "helpers/url_helper";
import Select from "react-select";
const CampusList = props => {
  const [error, setError] = useState(null);
  //const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedCampusval, setSelected] = useState('');

  const handleCampusChange = event => {
    //console.log('Label 👉️', event.target.selectedOptions[0].label);
    //console.log(event.target.value);
    setSelected(event.target.value);
    props.setCampusValue(event.target.value);
    // LocationList(event.target.value);
    const element = <LocationList campusid={event.target.value} />;
  };
 
  // Note: the empty deps array [] means
  // this useEffect will run once
  // similar to componentDidMount()
  //useEffect(() => {

  // UserValidated
    fetch(apiEndpoint+"/GetCampusList",
      {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json',
       },
       body: JSON.stringify({
         "strToken": sessionStorage.getItem("Clear_AuthUser"),
         
       })
     })    .then(res => res.json())
    .then(
      (result) => {
        // setIsLoaded(true);
        //console.log(result);
        //console.log(JSON.parse(result.Locations));
        setItems(JSON.parse(result.CampusList));
      },
      // Note: it's important to handle errors here
      // instead of a catch() block so that we don't swallow
      // exceptions from actual bugs in components.
      (error) => {
        // setIsLoaded(true);
        setError(error);
      }
    )
  //}, [])

  if (error) {
    return <div>Error: {error.message}</div>;
  } //else if (!isLoaded) {
  //   return <div>Loading...</div>;
  //} 
  else {
    return (
      <div>
        <select value={selectedCampusval} onChange={handleCampusChange} className="form-control">
          {
            items.map(item => (
              <option value={item.CampusID}>{item.CampusName}</option>
            ))}
        </select>
      </div>
    );
  }
}

const LocationList = props => {
  const [error, setError] = useState(null);
  const [items, setItems] = useState([]);
  const [selectedLocval, setSelected] = useState('');

  const handleLocChange = event => {
    //console.log('Label 👉️', event.target.selectedOptions[0].label);
    //console.log(event.target.value);
    setSelected(event.target.value);
    props.setLocValue(event.target.value);

  };

  // Note: the empty deps array [] means
  // this useEffect will run once
  // similar to componentDidMount()
  useEffect(() => {

    console.log(props.campusid);
    var intCampusID = props.campusid;
    // UserValidated
    fetch(apiEndpoint+"//GetLocationList", { 
      method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      "intCampusID": intCampusID,
      "strToken": sessionStorage.getItem("Clear_AuthUser")
    })
    
    })
      .then(res => res.json())
      .then(
        (result) => {
          //console.log(result);

          setItems(JSON.parse(result.Locations));
          //console.log(JSON.parse(items[0]["LocationID"]));
          //props.setLocValue(JSON.parse(items[0]["LocationID"]));
          // setSelected(JSON.parse(items[0]["LocationID"]));
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          setError(error);
        }
      )
  }, [])

  if (error) {
    return <div>Error: {error.message}</div>;
  }
  else {
    return (
      <div>
        <select value={selectedLocval} onChange={handleLocChange} className="form-control">
          {
            items.map(item => (
              <option value={item.LocationID} selected>{item.LocationName}</option>
            ))}
        </select>
      </div>
    );
  }
}

const ReportType = (props) => {
  const ReportTypeitems = [
    {
      value: 1,
      label: "Daily"
    },
    {
      value: 2,
      label: "Monthly"
    },
    {
      value: 3,
      label: "Custom"
    }
  ];
  // 👇️ initial value of empty string (first option)
  const [SelectedReportTypeitem, setSelectedReportTypeItem] = useState({ value: 1, label: "Daily" });

  const handleReportTypeChange = event => {
    debugger;
    //console.log('Label 👉️', event.label);
    console.log(event);
    setSelectedReportTypeItem(event);
    props.setReportType(event.value);
    if(event.value == 2)
    {
      const boxes = document.getElementsByClassName('monthlyrt');
      for (const box of boxes) {
        box.style.display = "block";
      }    }
    else{
      const boxes = document.getElementsByClassName('monthlyrt');
      
      for (const box of boxes) {
        box.style.display = "none";
      }      
    }
    if (event.value == 3) {
      const boxes = document.getElementsByClassName('customdttm');
      for (const box of boxes) {
        box.style.display = "block";
      }
    }
    else {
      const boxes = document.getElementsByClassName('customdttm');
      for (const box of boxes) {
        box.style.display = "none";
      }
    }
  };
  return (
    <Select value={SelectedReportTypeitem} options={ReportTypeitems} onChange={handleReportTypeChange}></Select>
  );
};

const ViolationType = (props) => {
  const ViolationTypeitems = [
    {
      value: 0,
      label: "All"
    },
    {
      value: 1,
      label: "Overspeed"
    },
    {
      value: 2,
      label: "No Helmet"
    }
  ];
  // 👇️ initial value of empty string (first option)
  const [ViolationTypeitem, setSelectedViolationTypeitem] = useState({ value: 0, label: "All" });

  const handleViolationTypeChange = event => {
    console.log(event);
    setSelectedViolationTypeitem(event);
    props.setViolationType(event.value);
  };
  return (
    <Select value={ViolationTypeitem} options={ViolationTypeitems} onChange={handleViolationTypeChange}></Select>
  );
};


const SpeedType = (props) => {
  const SpeedTypeitems = [
    {
      value: 1,
      label: "Default"
    },
    {
      value: 2,
      label: "Custom"
    }
  ];
  // 👇️ initial value of empty string (first option)
  const [SelectedSpeedTypeitem, setSelectedSpeedTypeItem] = useState({ value: 1, label: "Default" });

  const handleSpeedTypeChange = event => {
    //console.log('Label 👉️', event.label);
    console.log(event);
    setSelectedSpeedTypeItem(event);
    props.setSpeedType(event.value);
    if (event.value == '2') {
      const boxes = document.getElementsByClassName('customspeed');
      for (const box of boxes) {
        box.style.display = "block";
      }
    }
    else {
      const boxes = document.getElementsByClassName('customspeed');
      for (const box of boxes) {
        box.style.display = "none";
      }
    }
  };

  return (
    <Select value={SelectedSpeedTypeitem} options={SpeedTypeitems} onChange={handleSpeedTypeChange}></Select>

  );
};

const SearchData = (props) => {
  const [error, setError] = useState(null);

  // Note: the empty deps array [] means
  // this useEffect will run once
  // similar to componentDidMount()
  useEffect(() => {
    // UserValidated
    fetch(apiEndpoint+"/GetViolationLogs",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "intCampusID": selectedCampus,// 1,
          "intLocationID": selectedLoc,//1,
          "intReportType": selectedReportType,//1,
          "intSpeedType": selectedSpeedType,//1,
          "boolOnlyANPR": true,
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })
      })
      .then(res => res.json())
      .then(
        (result) => {
          //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
          //console.log(result);
          //setViolations(JSON.parse(result.Violations));
          props.setViolations(JSON.parse(result.Violations));
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          setError(error);
        }
      )
  }, [])

}
export { CampusList, LocationList, ReportType, SpeedType, SearchData,ViolationType }
